<p-select
  *ngIf="!multiple"
  [options]="options"
  size="small"
  [formControl]="control"
  [attr.tabindex]="tabIndex"
  optionLabel="label"
  optionValue="value"
  [placeholder]="placeholder"
  [showClear]="resettable"
  [filter]="filter || options.length >= 10"
  class="w-100"
></p-select>

<p-multiSelect
  *ngIf="multiple"
  [options]="options"
  size="small"
  [formControl]="control"
  [filter]="filter || options.length >= 10"
  optionLabel="label"
  optionValue="value"
  [placeholder]="placeholder"
  [showClear]="resettable"
  [showToggleAll]="false"
  [display]="'chip'"
  class="w-100"
>
</p-multiSelect>
